var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ev2-box stats"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"hcol1"},[_c('div',{staticClass:"title"},[_vm._v("Algo aqui...")]),_c('div',{staticClass:"subtitle"},[_vm._v("Dados mais relevantes...")])])]),_c('div',{staticClass:"body m-t"},[_vm._v(" Em construção. ")])])
}]

export { render, staticRenderFns }